export const VERSION_MANAGER_OPTIONS = {
  SOFTWARE: 0,
  BEAM_TABLES: 1
};
